import React from 'react';
import SEO from '../components/common/SEO';
import TermsHeroSection from '../components/terms/TermsHeroSection';
import TermsContentSection from '../components/terms/TermsContentSection';

const Terms = () => {
  return (
    <main className="w-full bg-[#f9f9f5] min-h-screen">
      <SEO
        title="Terms & Conditions"
        description="Review the terms and conditions for SeaSalt Creative website customization, service scope, and web hosting services."
      />
      <TermsHeroSection />
      <TermsContentSection />
    </main>
  );
};

export default Terms;
